<template>
  <div>
    <base-header
      class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
      style="
        min-height: 600px;
        background-size: cover;
        background-position: center top;
      "
    >
      <!-- Mask -->
      <span class="mask bg-gradient-success opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-10 col-md-12">
            <h1 class="display-2 text-white">Hola Usuario</h1>
            <p class="text-white mt-0 mb-5">
              Puede arrastrar los ejercicios dentro del mismo día para ordenarlos. Pero recuerde, al finalizar, pulsar sobre el botón de guardar.
            </p>
            
            <router-link :to="{ name: 'Ver Rutina', params: { rutinaId: rutinaId}}" class="btn btn-info"><span>Volver a la rutina</span></router-link>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-xl-12 order-xl-1">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-8">
                  <h3 class="mb-0">Ejercicios de la rutina: {{rutina_name}}</h3>
                </div>
                <div v-if="rutina_exercices == 0" class="col-3 col-sm-3 col-lg-3">
            
                    <Select2 id="clonador" class="form-control-alternative" v-model="rutina_to_clone" :options="rutinas_select" :settings="{ width:'100%', closeOnSelect: 'true' }"  @change="myChangeEvent($event)" @select="mySelectEvent($event)" />
                </div>
                <div v-if="rutina_exercices == 0" class="col-1 col-sm-1 col-lg-1"><button class="btn btn-primary btn-block" @click="clonarEjercicios">Clonar</button></div>
                <div v-else class="col text-right">
                  <base-button @click="updateOrder" type="primary" size="sm"> Guardar orden</base-button>
                </div>
              </div>
            </div>
            <template>
              <h6 class="heading-small text-muted mb-4">Ejercicios</h6>
              <div class="row" id="container-ejercicios">
                        <div class="col-12 col-sm-12 col-lg-6 col-xl"><span>Lunes</span>
                        <div class="media align-items-center">
                              <div @click="modals.modal1 = true; add_ejercicio.dia = 'lunes'" class="avatar rounded-circle mr-3 align-items-center" >
                                  <img alt="Añadir ejercicio" src="img/add.png">
                              </div>
                          </div>
                        <draggable v-model="lunes" group="lunes" @start="drag=true" @end="drag=false" @change="orderDay('lunes')">
                          <div v-for="element in lunes" :key="element.id">
                            <ejercicio-card 
                              :series="element.series"
                              :repeticiones="element.repeticiones"
                              :descanso="element.descanso"
                              :ejercicio_id="element.ejercicio_id"
                              :rutina_id="rutinaId"
                              :uid="element.id"
                              showDelete=true>
                            </ejercicio-card>
                          </div>
                        </draggable>
                        </div>
                        <div class="col-12 col-sm-12 col-lg-6 col-xl"><span>Martes</span>
                        <div class="media align-items-center">
                                        <div @click="modals.modal1 = true; add_ejercicio.dia = 'martes'" class="avatar rounded-circle mr-3 align-items-center" >
                                            <img alt="Añadir ejercicio" src="img/add.png">
                                        </div>
                                    </div>
                        <draggable v-model="martes" group="martes" @start="drag=true" @end="drag=false" @change="orderDay('martes')">
                          <div v-for="element in martes" :key="element.id">
                            <ejercicio-card 
                              :series="element.series"
                              :repeticiones="element.repeticiones"
                              :descanso="element.descanso"
                              :ejercicio_id="element.ejercicio_id"
                              :rutina_id="rutinaId"
                              :uid="element.id"
                              showDelete=true>
                            </ejercicio-card>
                          </div>
                        </draggable>
                        </div>

                        <div class="col-12 col-sm-12 col-lg-6 col-xl"><span>Miércoles</span>
                        <div class="media align-items-center">
                                        <div @click="modals.modal1 = true; add_ejercicio.dia = 'miercoles'" class="avatar rounded-circle mr-3 align-items-center" >
                                            <img alt="Añadir ejercicio" src="img/add.png">
                                        </div>
                                    </div>
                        <draggable v-model="miercoles" group="miercoles" @start="drag=true" @end="drag=false" @change="orderDay('miercoles')">
                          <div v-for="element in miercoles" :key="element.id">
                            <ejercicio-card 
                              :series="element.series"
                              :repeticiones="element.repeticiones"
                              :descanso="element.descanso"
                              :ejercicio_id="element.ejercicio_id"
                              :rutina_id="rutinaId"
                              :uid="element.id"
                              showDelete=true>
                            </ejercicio-card>
                          </div>
                        </draggable>
                        </div>
                        <div class="col-12 col-sm-12 col-lg-6 col-xl"><span>Jueves</span>
                        <div class="media align-items-center">
                                        <div @click="modals.modal1 = true; add_ejercicio.dia = 'jueves'" class="avatar rounded-circle mr-3 align-items-center" >
                                            <img alt="Añadir ejercicio" src="img/add.png">
                                        </div>
                                    </div>
                        <draggable v-model="jueves" group="jueves" @start="drag=true" @end="drag=false" @change="orderDay('jueves')">
                          <div v-for="element in jueves" :key="element.id">
                            <ejercicio-card 
                              :series="element.series"
                              :repeticiones="element.repeticiones"
                              :descanso="element.descanso"
                              :ejercicio_id="element.ejercicio_id"
                              :rutina_id="rutinaId"
                              :uid="element.id"
                              showDelete=true>
                            </ejercicio-card>
                          </div>
                        </draggable>
                        </div>
                        <div class="col-12 col-sm-12 col-lg-6 col-xl"><span>Viernes</span>
                        <div class="media align-items-center">
                            <div @click="modals.modal1 = true; add_ejercicio.dia = 'viernes'" class="avatar rounded-circle mr-3 align-items-center" >
                                <img alt="Añadir ejercicio" src="img/add.png">
                            </div>
                        </div>
                        <draggable v-model="viernes" group="viernes" @start="drag=true" @end="drag=false" @change="orderDay('viernes')">
                          <div v-for="element in viernes" :key="element.id">
                            <ejercicio-card 
                              :series="element.series"
                              :repeticiones="element.repeticiones"
                              :descanso="element.descanso"
                              :ejercicio_id="element.ejercicio_id"
                              :rutina_id="rutinaId"
                              :uid="element.id"
                              showDelete=true>
                            </ejercicio-card>
                          </div>
                        </draggable>
                        </div>
                        <div class="col-12 col-sm-12 col-lg-6 col-xl col-xl"><span>Sábado</span>
                        <div class="media align-items-center">
                            <div @click="modals.modal1 = true; add_ejercicio.dia = 'sabado'" class="avatar rounded-circle mr-3 align-items-center" >
                                  <img alt="Añadir ejercicio" src="img/add.png">
                            </div>
                        </div>
                        <draggable v-model="sabado" group="sabado" @start="drag=true" @end="drag=false" @change="orderDay('sabado')">
                          <div v-for="element in sabado" :key="element.id">
                            <ejercicio-card 
                              :series="element.series"
                              :repeticiones="element.repeticiones"
                              :descanso="element.descanso"
                              :ejercicio_id="element.ejercicio_id"
                              :rutina_id="rutinaId"
                              :uid="element.id"
                              showDelete=true>
                            </ejercicio-card>
                          </div>
                        </draggable>
                        </div>
                    </div>
            </template>
          </card>
        </div>
      </div>
    </div>
    <modal :show.sync="modals.modal1">
            <h3 slot="header" class="modal-title" id="modal-title-default">Añadir ejercicio al {{modals.modal1}}</h3>

            <form @submit.prevent="onFormSubmit">
                <label class="form-control-label" for="ejercicio_id">Ejercicio</label>
                <br>
                <Select2 id="ejercicio_id" class="form-control-alternative" v-model="add_ejercicio.ejercicio_id" :options="ejercicios_select" :settings="{ width:'100%', closeOnSelect: 'true' }"  @change="myChangeEvent($event)" @select="mySelectEvent($event)" />
                <small v-if="ejercicio_null" style="color:red;">Debe seleccionar un ejercicio</small>
                <base-input
                    alternative=""
                    label="Series"
                    placeholder="Series"
                    type="number"
                    input-classes="form-control-alternative"
                    v-model="add_ejercicio.series"/>

                <base-input
                    alternative=""
                    label="Repeticiones"
                    placeholder="Repeticiones"
                    type="number"
                    input-classes="form-control-alternative"
                    v-model="add_ejercicio.repeticiones"/>

                <base-input
                    alternative=""
                    label="Descanso"
                    placeholder="Descanso"
                    input-classes="form-control-alternative"
                    v-model="add_ejercicio.descanso"/>

                <input type="hidden" name="dia" v-model="add_ejercicio.dia">
                <button id="save" class="btn btn-primary btn-block">Añadir</button>
            </form>
            
            <template slot="footer">

                <base-button type="link" class="ml-auto" @click="modals.modal1 = false">Cancelar</base-button>
            </template>
        </modal>
  </div>
</template>
<script>
import { db } from '../../firebaseDb';
import { auth } from '../../firebaseDb';
import EjercicioCard from '@/components/EjercicioCard';
import Select2 from 'v-select2-component';
import draggable from 'vuedraggable';

export default {
  name: "show-rutina",
  props: {
        rutinaId: {
          type: String,
          defalut: "Nombre rutina"
        },
        rutina_name: {
        type: String,
        default: 'Nombre rutina'
        },
  },
  components:{
      EjercicioCard,
      Select2,
      draggable
  },
  data() {
    return {
      user: auth.currentUser,
      lunes: [],
      martes: [],
      miercoles: [],
      jueves: [],
      viernes: [],
      sabado: [],
      modals:{
          modal1: false
      },
      add_ejercicio:{
        descanso: "",
        dia: "",
        ejercicio_id: "",
        repeticiones: 0, 
        series: 0   
      },
      ejercicios_select: [],
      ejercicio_null: false,
      rutinas_select: [],
      rutina_to_clone: null,
      rutina_exercices: 0,

    };
  },
  created: function() {
    this.creado();
  },
  methods: {
    creado(){
      var self = this;
    db.collection('users').doc(this.user.uid).collection('rutinas').doc(this.rutinaId).collection('ejercicios').where('dia','==', 'lunes').orderBy("order", "asc").get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let item = doc.data()
          item.id = doc.id
          item.series = parseInt(doc.data().series, 10);
          item.repeticiones = parseInt(doc.data().repeticiones, 10);
          this.lunes.push(item)
          this.rutina_exercices++;
        })
      })
      db.collection('users').doc(this.user.uid).collection('rutinas').doc(this.rutinaId).collection('ejercicios').where('dia','==', 'martes').orderBy("order", "asc").get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let item = doc.data()
          item.id = doc.id
          item.series = parseInt(doc.data().series, 10);
          item.repeticiones = parseInt(doc.data().repeticiones, 10);
          this.martes.push(item)
          this.rutina_exercices++;
        })
      })
      db.collection('users').doc(this.user.uid).collection('rutinas').doc(this.rutinaId).collection('ejercicios').where('dia','==', 'miercoles').orderBy("order", "asc").get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let item = doc.data()
          item.id = doc.id
          item.series = parseInt(doc.data().series, 10);
          item.repeticiones = parseInt(doc.data().repeticiones, 10);
          this.miercoles.push(item)
          this.rutina_exercices++;
        })
      })
      db.collection('users').doc(this.user.uid).collection('rutinas').doc(this.rutinaId).collection('ejercicios').where('dia','==', 'jueves').orderBy("order", "asc").get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let item = doc.data()
          item.id = doc.id
          item.series = parseInt(doc.data().series, 10);
          item.repeticiones = parseInt(doc.data().repeticiones, 10);
          this.jueves.push(item)
          this.rutina_exercices++;
        })
      })
      db.collection('users').doc(this.user.uid).collection('rutinas').doc(this.rutinaId).collection('ejercicios').where('dia','==', 'viernes').orderBy("order", "asc").get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let item = doc.data()
          item.id = doc.id
          item.series = parseInt(doc.data().series, 10);
          item.repeticiones = parseInt(doc.data().repeticiones, 10);
          this.viernes.push(item)
          this.rutina_exercices++;
        })
      })
      db.collection('users').doc(this.user.uid).collection('rutinas').doc(this.rutinaId).collection('ejercicios').where('dia','==', 'sabado').orderBy("order", "asc").get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let item = doc.data()
          item.id = doc.id
          item.series = parseInt(doc.data().series, 10);
          item.repeticiones = parseInt(doc.data().repeticiones, 10);
          this.sabado.push(item)
          this.rutina_exercices++;
        })
      })
    db.collection('ejercicios').get()
        .then(snapshot => {
            snapshot.forEach(doc => {
                let item = doc.data()
                item.id = doc.id
                item.text = doc.data().ejercicio_name
                this.ejercicios_select.push(item)
            })
        })
    db.collection('users').doc(this.user.uid).collection('rutinas').orderBy("fecha_fin", "desc").get()
    .then(snapshot => {
      snapshot.forEach(doc => {
        let item = doc.data()
        item.id = doc.id
        item.text = doc.data().rutina_name
        this.rutinas_select.push(item)
      })
    })
    },
    onFormSubmit(event) {
      event.preventDefault();
      if (this.add_ejercicio.ejercicio_id == '' || this.add_ejercicio.ejercicio_id == null) {
        this.ejercicio_null = true;
      } else {
        this.ejercicio_null = false;
        db.collection('users').doc(this.user.uid).collection('rutinas').doc(this.rutinaId).collection('ejercicios')
        .add({
          descanso: this.add_ejercicio.descanso,
          dia: this.add_ejercicio.dia,
          ejercicio_id: this.add_ejercicio.ejercicio_id,
          repeticiones: this.add_ejercicio.repeticiones,
          series: this.add_ejercicio.series,
          order: 0

        }).then(() => {
                        
          this.add_ejercicio.dia = ''
          this.add_ejercicio.ejercicio_id = ''
          this.lunes = [];
          this.martes = [];
          this.miercoles = [];
          this.jueves = [];
          this.viernes = [];
          this.sabado = [];
          this.creado();
          this.modals.modal1 = false;
        }).catch((error) => {
          console.log(error);
        });
      }
    },
    myChangeEvent(val){
            console.log(val);
    },
    mySelectEvent({id, text}){
        console.log({id, text})
    },
    orderDay(key){
      let i = 1;
      switch (key) {
        case 'lunes':
            this.lunes.forEach(element => {
              element.order = i;
              i++;
            });
          break;
        case 'martes':
            this.martes.forEach(element => {
              element.order = i;
              i++;
            });
          break;
        case 'miercoles':
            this.miercoles.forEach(element => {
              element.order = i;
              i++;
            });
          break;
        case 'jueves':
            this.jueves.forEach(element => {
              element.order = i;
              i++;
            });
          break;
        case 'viernes':
            this.viernes.forEach(element => {
              element.order = i;
              i++;
            });
          break;
        case 'sabado':
            this.sabado.forEach(element => {
              element.order = i;
              i++;
            });
          break;      
        default:
          break;
      }
    },
    updateOrder(){
      this.lunes.forEach(element => {
        db.collection('users').doc(this.user.uid).collection('rutinas').doc(this.rutinaId).collection('ejercicios').doc(element.id)
                .update({
                  order: element.order,
                }).then(() => {
                    //alert("Se ha editado correctamente");
                    this.track();

                }).catch((error) => {
                    console.log(error);
                });
      });

      this.martes.forEach(element => {
        db.collection('users').doc(this.user.uid).collection('rutinas').doc(this.rutinaId).collection('ejercicios').doc(element.id)
                .update({
                  order: element.order,
                }).then(() => {
                    //alert("Se ha editado correctamente");

                }).catch((error) => {
                    console.log(error);
                });
      });

      this.miercoles.forEach(element => {
        db.collection('users').doc(this.user.uid).collection('rutinas').doc(this.rutinaId).collection('ejercicios').doc(element.id)
                .update({
                  order: element.order,
                }).then(() => {
                    //alert("Se ha editado correctamente");

                }).catch((error) => {
                    console.log(error);
                });
      });

      this.jueves.forEach(element => {
        db.collection('users').doc(this.user.uid).collection('rutinas').doc(this.rutinaId).collection('ejercicios').doc(element.id)
                .update({
                  order: element.order,
                }).then(() => {
                    //alert("Se ha editado correctamente");

                }).catch((error) => {
                    console.log(error);
                });
      });

      this.viernes.forEach(element => {
        db.collection('users').doc(this.user.uid).collection('rutinas').doc(this.rutinaId).collection('ejercicios').doc(element.id)
                .update({
                  order: element.order,
                }).then(() => {
                    //alert("Se ha editado correctamente");

                }).catch((error) => {
                    console.log(error);
                });
      });

      this.sabado.forEach(element => {
        db.collection('users').doc(this.user.uid).collection('rutinas').doc(this.rutinaId).collection('ejercicios').doc(element.id)
                .update({
                  order: element.order,
                }).then(() => {
                    //alert("Se ha editado correctamente");

                }).catch((error) => {
                    console.log(error);
                });
      });
    },
    track() {
        this.$gtag.event("rutina_exercices_ordered", {
          'event_category': "rutina",
          'event_label': "ordered_rutina_exercices",
          'value': 1
        })
    },
    clonarEjercicios(){
      var self = this;
      if (this.rutina_to_clone) {
        db.collection('users').doc(this.user.uid).collection('rutinas').doc(this.rutina_to_clone).collection('ejercicios').get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            let item = doc.data()
            item.id = doc.id
            

            db.collection('users').doc(this.user.uid).collection('rutinas').doc(this.rutinaId).collection('ejercicios')
            .add({
              descanso: item.descanso,
              dia: item.dia,
              ejercicio_id: item.ejercicio_id,
              repeticiones: item.repeticiones,
              series: item.series,
              order: item.order

            }).then(() => {

            }).catch((error) => {
              console.log(error);
            });
          })
          this.creado();
        })
      }
    }
  }
}
</script>
<style>
img{
  max-width: 95%;
}
#container-ejercicios{
    overflow-x: auto;
    white-space: nowrap;
}

#ejercicio_id{
    width: 100%;
    height: calc(1.5em + 1.20rem + 2px);
}

@media (min-width: 1200px) and ( max-width: 1536px) {
  #container-ejercicios{
    overflow-x: auto;
    white-space: nowrap;
    display: block;
  }
}

</style>